export const API_DOMAIN = process.env.API_DOMAIN || "/api"

export const makeHttpEndpoint = (endpoint: string): string => {
    if(!endpoint.startsWith("/")) {
        endpoint = "/" + endpoint
    }
    return API_DOMAIN + endpoint;
}